
import '../../src/assets/style/uae-symbol.css';
export const DirhamSymbol = () => (
 <span class="dirham-symbol">&#xea;</span>
);